var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icons-container"},_vm._l((_vm.socialLinks),function(socialLink){return _c('v-btn',{key:socialLink.icon,attrs:{"text":"","icon":"","href":socialLink.url,"target":"_blank"}},[_c('v-icon',[_vm._v("\n            "+_vm._s(socialLink.icon)+"\n        ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }